import { Injectable } from '@angular/core';
import { Subject, Observer, Observable, Subscription } from 'rxjs/Rx';
import { environment } from 'environments/environment';
import { JsondatahandlerService } from './jsondatahandler.service';
import { IntervalObservable } from 'rxjs/observable/IntervalObservable';

import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})

export class WebsocketClientService {
  public socket: Subject<any>;
  private lastCall: Object;
  private resendLast: boolean;
  public socketStrings;
  public socketInfo = ["WS1", "WS2"];
  public socketsConnected = [false, false, false, false];
  public logInCheck = [false, false, false, false];
  public sockets = [];
  public currentSocket = 0;
  public currentServerId = 0;
  constructor(private jsonDataHandler: JsondatahandlerService, private auth: AuthService) {

    IntervalObservable.create(3000).takeWhile(() => true).subscribe(() => { this.pingSocket() });
    if (environment.production) {
      this.socketStrings = ["wss://ws1.visualactor.com:443", "wss://ws2.visualactor.com:443"];
      this.socketInfo = ["WS1", "WS2"];
    } else {
      this.socketStrings = ["wss://devel.visualactor.com:10002"];
      this.socketInfo = ["devel"];
    }
    //   IntervalObservable.create(5000).takeWhile(() => this.tryRelog).subscribe(() => { this.doRelog() });
  }



  public pingSocket() {
    this.sendMessageToSocket('{"action": "ping","call_from": "ping"}');
    if (this.auth.tryRelog) {
      if (this.auth.loggedIn) {
        this.auth.tryRelog = false;
      }
      if (!this.auth.loggedIn) {
        this.sendMessageToSocket(this.auth.relogUser());
      }
    }

  }

  public createWebsocket(): Subject<MessageEvent> {
    //let socket = new WebSocket("wss://ws.2.visualactor.com:443");

    //let socket = new WebSocket("wss://devel.visualactor.com:10002");
    let socket = new WebSocket(this.socketStrings[this.currentSocket]);
    socket.addEventListener('error', (err) => {
      this.currentSocket++;
      if (this.currentSocket < this.socketStrings.length) {
        this.StartWebSocket();
      } else {
        this.currentSocket = 0;
      }
    });

    let observer = {
      next: (data: Object) => {
        //console.log("test");
        if (socket.readyState == 1) {
          socket.send(data.toString());
        } else if (socket.readyState == 3) {
          if (this.auth.loggedIn) {
            this.auth.tryRelog = true;
            this.auth.loggedIn = false;
          }
          this.jsonDataHandler.connected = false;
          this.StartWebSocket();
        }
      },
      error: (data: Object) => {
        console.log(data);
        //console.log("error");
      },
      close: (data: Object) => {
        console.log("closed");
      }
    };

    let observable = Observable.create(
      (observer: Observer<MessageEvent>) => {
        socket.onmessage = observer.next.bind(observer);
        //socket.onerror = observer.error.bind(observer);
        socket.onclose = observer.complete.bind(observer);
        return socket.close.bind(socket);
      }
    );

    return Subject.create(observer, observable);
  }

  public sendMessageToSocket(data: Object) {
    this.sockets[this.currentSocket].next(data);
  }

  public StartWebSocket() {
    //console.log("connect to: " + this.currentSocket);
    //console.log(this.socketStrings[this.currentSocket]);
    if (!this.jsonDataHandler.connected) {
      this.sockets[this.currentSocket] = this.createWebsocket();
      this.sockets[this.currentSocket].subscribe(message => {
        this.jsonDataHandler.ProcessSocketData(message.data);
      }
      );
    }

  }

  public GetConnectedSocket() {
    return this.socketInfo[this.currentSocket];
  }
}

